"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-toast";
/*---------------------------------------------*/

function ToastInner(props, ref) {
  var customClasses = [BASE_CLASS + '--' + (props.variant || 'default')];
  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS, customClasses);
  var style = (0, _useStyleBuilder.default)(props);
  var title = props.title ? /*#__PURE__*/_react.default.createElement(_.Text, {
    className: BASE_CLASS + '__title',
    color: "--neutral-50",
    bold: true
  }, props.title) : null;
  var content = props.content ? /*#__PURE__*/_react.default.createElement(_.Text, {
    className: BASE_CLASS + '__content',
    color: "--neutral-50",
    size: "small"
  }, props.content) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    className: BASE_CLASS + '__icon',
    icon: "checkmarkFilled",
    size: 20
  }), /*#__PURE__*/_react.default.createElement(_.Icon, {
    className: BASE_CLASS + '__close',
    icon: "close",
    onClick: props.onClose,
    size: 20
  }), title, content);
}
/*---------------------------------------------*/


var Toast = /*#__PURE__*/(0, _react.forwardRef)(ToastInner);
var _default = Toast;
/*---------------------------------------------*/

exports.default = _default;
Toast.METADATA = {
  name: 'Toast',
  props: [{
    name: "variant",
    type: "string",
    default: "default",
    options: [{
      value: "default"
    }, {
      value: "success"
    }, {
      value: "error"
    }]
  }, {
    name: "title",
    type: "string",
    default: "Toast Title"
  }, {
    name: "content",
    type: "string",
    default: "Toast Content"
  }, {
    name: "onClose",
    type: "function"
  }]
};